export const languageElements = {
    items: {
      "header-text": {
        hu: "ÜDVÖZÖLJÜK PORTÁLUNKON!",
        de: "WILLKOMMEN AUF UNSEREM PORTAL!",
        en: "WELCOME TO OUR PORTAL!",
      },

      "body-introduction": {
        hu: "Rendszerünk az alábbi adatokat tartja nyilván Önről:",
        de: "Unser System erfasst folgende Daten über Sie:",
        en: "Our system records the following data about you:",
      },

      "field-email": {
        hu: "Email:",
        de: "Email:",
        en: "Email:",
      },

      "field-name": {
        hu: "Felhasználó neve:",
        de: "Benutzerame:",
        en: "Username:",
        },
    },
  };
